import * as React from "react"
import { createRoot } from "react-dom/client"
import { App } from "../novus/novus-app"

const rootEl = document.getElementById("novus-root")
if (rootEl) {
  console.log("found root")
  const root = createRoot(rootEl)
  root.render(<App />)
} else {
  console.error("missing novus-root element")
}
